import { useTheme } from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'

type KeyValueProps = {
  label: string
  value?: string
}

const KeyValue = ({ label, value }: KeyValueProps) => {
  const theme = useTheme()

  return (
    <>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {label}
      </Span>
      <Span type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
        {value}
      </Span>
    </>
  )
}

export { KeyValue }
